import Dialog from '@material-ui/core/Dialog'
import styled, { css } from 'styled-components'
import { Header } from 'style/DialogStyles'
import { isStandaloneApp } from 'utils/Utils'

import { standaloneMedia } from './standaloneMedia'

export const StyledDialog = styled(Dialog).attrs({
  ...(isStandaloneApp && { hideBackdrop: true, transitionDuration: 0 }),
})`
  .MuiDialog-paper {
    border-radius: 22px;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.app.controlBorder};
    box-shadow: 0 28px 80px rgba(0, 0, 0, 0.36);
  }

  ${standaloneMedia(css`
    .MuiDialog-container .MuiPaper-root {
      box-shadow: none;
      border-radius: 0;
    }
  `)}
`

export const StyledHeader = styled(Header)`
  ${standaloneMedia(css`
    padding-top: 47px;
  `)}
`
